import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ reference }) => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 bg-error/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <Icon name="PackageX" size={40} className="text-error" />
        </div>
        
        <h2 className="text-2xl font-bold text-foreground mb-3">
          Colis introuvable
        </h2>
        
        <p className="text-muted-foreground mb-2">
          Aucun envoi trouvé avec la référence:
        </p>
        
        <div className="inline-block bg-error/10 text-error px-4 py-2 rounded-md font-mono text-sm mb-6">
          {reference}
        </div>
        
        <p className="text-sm text-muted-foreground mb-8">
          Veuillez vérifier votre numéro de référence et réessayer.\nSi le problème persiste, contactez notre service client.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/home-tracking">
            <Button variant="default" iconName="Search" iconPosition="left">
              Nouvelle recherche
            </Button>
          </Link>
          
          <a href="https://wa.me/33651988621" target="_blank" rel="noopener noreferrer">
            <Button variant="outline" iconName="MessageCircle" iconPosition="left">
              Contacter le support
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;